import { LocationContext } from "@freightsimple/generated-dashboard-openapi-client/models/LocationContext";
import { Link } from "@freightsimple/ui-core/Typography/Link";
import { Stack } from "@freightsimple/ui-core/ComponentLayout/Stack";
import { T } from "@freightsimple/ui-core/Typography/T";
import { Tooltip } from "@freightsimple/ui-core/Feedback/Tooltip";

import type {
  AccessorialQuestionBubble,
  LocationsAccessorialQuestionBubbleProps,
} from "../Types/LocationsAccessorialQuestionBubbleTypes";
import { describeLocationContext } from "@/Helpers/describeLocationContext";

const LocationsLiftGateRequiredQuestionBubble: AccessorialQuestionBubble = (
  props: LocationsAccessorialQuestionBubbleProps,
) => {
  let description =
    props.locationContext === LocationContext.Pickup
      ? `Check this box if you are unable to load the freight onto the truck at your pickup location.`
      : `Check this box if you are unable to unload the freight off the truck at your delivery location.`;

  description += ` For example, if you don't have a dock, loading bay, or a forklift.`;

  return (
    <Tooltip
      interactive
      variant="info"
      content={
        <Stack gap={2}>
          <T weight="bold">
            {`Lift gate required at ${describeLocationContext(props.locationContext)}`}
          </T>
          <T size="xs" color="secondary">
            {description}
          </T>
          <Link
            href="https://help.freightsimple.com/freight-101/special-services/lift-gate-required"
            external
          >
            Learn more
          </Link>
        </Stack>
      }
    />
  );
};
export default LocationsLiftGateRequiredQuestionBubble;
